import script from "./SmallOrderMindmapManage.vue?vue&type=script&lang=ts&setup=true"
export * from "./SmallOrderMindmapManage.vue?vue&type=script&lang=ts&setup=true"

import "./SmallOrderMindmapManage.vue?vue&type=style&index=0&id=2f01235c&lang=css"

const __exports__ = script;

export default __exports__